"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import { FaArrowRight } from "react-icons/fa";
import { Button } from "@/components/ui";
import { cx } from "@/lib/tailwind-utils";
interface FloatingActionPillProps {
  /** Left-side text/content. */
  children: React.ReactNode;
  /** Button label. When omitted, the action button is hidden. */
  actionLabel?: string;
  onAction?: () => void;
  /**
   * Controls the button's animated reveal. Use this to gate the action on
   * a selection ("Continue" only after items selected). When false, the
   * button slides out and stops being clickable.
   */
  actionVisible?: boolean;
  /**
   * Optional click handler for the content area. When set, the content
   * renders as a button (with hover affordance) instead of a static div.
   */
  onContentClick?: () => void;
  /** Accessible label for the content button. Required when `onContentClick` is set. */
  contentAriaLabel?: string;
  /** Extra classes for outer wrapper — typically positioning (`fixed …` etc.). */
  className?: string;
}

/**
 * Pill-shaped action bar used by self-schedule's `FloatingServiceCounter`
 * and the online-purchase floating cart. Owns the visual treatment
 * (pill shape, blur, shadow, button reveal animation) so consumers only
 * supply content, label, and positioning.
 */
const FloatingActionPill: React.FC<FloatingActionPillProps> = t0 => {
  const $ = _c(18);
  const {
    children,
    actionLabel,
    onAction,
    actionVisible: t1,
    onContentClick,
    contentAriaLabel,
    className
  } = t0;
  const actionVisible = t1 === undefined ? true : t1;
  let t2;
  let t3;
  if ($[0] !== actionLabel || $[1] !== actionVisible || $[2] !== children || $[3] !== className || $[4] !== contentAriaLabel || $[5] !== onContentClick) {
    const contentClasses = cx("whitespace-nowrap p-2 pl-3 pr-0.5", actionVisible && actionLabel && "pr-0");
    if ($[8] !== className) {
      t2 = cx("flex items-center gap-2 rounded-full", "border border-border bg-background/70 shadow-md backdrop-blur-md", "text-body-strong", "transition-all duration-300", className);
      $[8] = className;
      $[9] = t2;
    } else {
      t2 = $[9];
    }
    t3 = onContentClick ? <button type="button" onClick={onContentClick} aria-label={contentAriaLabel} className={cx(contentClasses, "cursor-pointer rounded-l-full transition-colors", "hover:bg-hover focus:outline-none focus-visible:ring-2 focus-visible:ring-primary")}>{children}</button> : <div className={contentClasses}>{children}</div>;
    $[0] = actionLabel;
    $[1] = actionVisible;
    $[2] = children;
    $[3] = className;
    $[4] = contentAriaLabel;
    $[5] = onContentClick;
    $[6] = t2;
    $[7] = t3;
  } else {
    t2 = $[6];
    t3 = $[7];
  }
  let t4;
  if ($[10] !== actionLabel || $[11] !== actionVisible || $[12] !== onAction) {
    t4 = actionLabel && <Button variant="primary" onClick={onAction} disabled={!actionVisible} aria-hidden={!actionVisible} tabIndex={actionVisible ? undefined : -1} className={cx("group/continue-button cursor-pointer overflow-hidden whitespace-nowrap rounded-e-full py-2", "transition-all duration-500 ease-in-out", "max-w-40 hover:pr-6", !actionVisible && "!max-w-0 !px-0 opacity-0")}><span>{actionLabel}</span><FaArrowRight className="ml-2 flex-shrink-0 transition-all duration-300 group-hover/continue-button:translate-x-2" /></Button>;
    $[10] = actionLabel;
    $[11] = actionVisible;
    $[12] = onAction;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== t2 || $[15] !== t3 || $[16] !== t4) {
    t5 = <div className={t2}>{t3}{t4}</div>;
    $[14] = t2;
    $[15] = t3;
    $[16] = t4;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  return t5;
};
export default FloatingActionPill;